<template>
    <div class="page white_bg">

        <div>
            <header class="pageHeader paddingH16 paddingV12 white_bg max375 centered" style="line-height: 24px;">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 24px">
                            <span class="icon leftAngleBracketIcon floatL" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font20r primaryTextColor bold">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 24px">
<!--                            <router-link class="primaryTextColor bold" to="">链接</router-link>-->
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">

            <div class="alignC" style="height: 110px; box-sizing: border-box; padding-top: 22px; background: #FBFBFB;">
                <div class="size48 imageArea centered">
                    <img class="fullSpace cover circle" :src="userInstance.headerImg" v-if="userInstance"/>
                </div>
                <div class="marginT8">
                    {{ userInstance ? userInstance.userName : '' }}
                </div>
            </div>

            <div style="padding: 14px 6px;">
                <div class="clearfix grey333">
                    <div class="fl w50p">我的下载次数</div>
                    <div class="fl w50p alignR">
                        <span class="orange marginR4">{{ downloadCount }}次</span>
                        <span>&gt;</span>
                    </div>
                </div>
            </div>

            <div class="topBorderBBB">
                <van-tabs v-model="activeType" sticky swipeable title-inactive-color="#5B616C" title-active-color="#333"
                          line-width="24" line-height="4">
                    <van-tab title="详情" title-style="font-size: 14px;">
                        <article class="paddingH8">
                            <div class="content" v-html="vipEnjoyData ? vipEnjoyData.detail[0].content : ''"></div>
                        </article>
                    </van-tab>

                    <van-tab title="充值中心" title-style="font-size: 14px;">

                        <div class="generalPagePaddingH max375 centered" style="padding-top: 24px;" v-if="view === 'recharge'">

                            <div class="bgFAFAFA clearfix" style="line-height: 1.285em; padding: 14px 12px;">
                                <div class="fl font14r grey20">我的下载次数：{{downloadCount}}次</div>
                                <div class="fr font12r lightGrey">
                                    <router-link class="lightGrey" to="/recharge/history">
                                        充值明细
                                        <i class="icon moreContentRightAngleBracketIcon" style="width: 10px; height: 10px; margin-left: 3px;"></i>
                                    </router-link>
                                </div>
                            </div>

                            <div class="font14r roundBorder8" style="background-color: hsla(230, 30%, 96%, 1); line-height: 1.285em;
                    padding: 14px 12px; margin-top: 32px;">
                                <input type="text" class="inputbox block w100p no_bg noBorder noOutline lightGrey"
                                       placeholder="请输入账号或手机帐号进行充值" v-model="dataItem.account"/>
                            </div>

                            <div class="marginT24">
                                <div class="titleArea">
                                    <span class="font14r grey20 bold">充值数额</span>
                                    <span class="font12r lightGrey">（1元人民币=1次下载次数）</span>
                                </div>
                                <div class="optionsArea grid3column marginT16" style="grid-gap: 12px 11px;">
                                    <div class="optionItem roundBorder8 alignC" :class="{active : activeOption == optionItem}"
                                         v-for="(optionItem, index) in dataList" :key="index"
                                         @click="activeOption = optionItem">
                                        <span class="font14r countText">{{optionItem.rechargeCount}}次下载</span><br/>
                                        <span class="font12r priceText">{{optionItem.price + '元'}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="lightGrey" style="margin-top: 56px;">
                                <div class="font12r">温馨提示：</div>
                                <buyNotice source="courseware_recharge_notice"/>
                                <!--                    <p class="font10r marginT12" style="line-height: 1.7em">-->
                                <!--                        1、下载额度仅限于课件网小工具内的课件下载消费，无法在其他系统使用；<br/>-->
                                <!--                        2、下载额度为虚拟币，充值后不会过期，但无法兑换现金进行提现。<br/>-->
                                <!--                        3、充值金额越大，赠送次数越多，充10元送2次，充20元送5次，充30元送10次，充50元送20次，充100元送50次。-->
                                <!--                    </p>-->
                            </div>

                        </div><!-- end recharge view -->

                        <div class="inner generalPagePaddingH max375 centered" v-if="view === 'success'">
                            <div class="alignC" style="padding-top: 32px; padding-bottom: 56px;">
                                <img src="data:image/png;base64,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" width="206" height="95" alt=""/>
                            </div>

                            <div class="alignC">
                                <wx-open-launch-weapp :username="externalApp.rcWechatApp.appId"
                                                      @launch="onLaunchWeApp" @error="onLaunchWeAppError">
                                    <script type="text/wxtag-template">
                                        <style>
                                            .orangeButton {
                                                display: block;
                                                width: 100%;
                                                border: none;
                                                height: 48px;
                                                line-height: 48px;
                                                border-radius: 24px;
                                                padding: 0 5em;
                                                background: linear-gradient(90deg, #FFA115 0%, #FFBF60 100%);
                                                color: white;
                                            }
                                        </style>
                                        <!-- http://shixun-test-media.oss-cn-shenzhen.aliyuncs.com/vl/img/c15a443c1efb4fecac0183965b55e47f.png -->
                                        <button type="button" class="orangeButton">返回课件小程序</button>
                                    </script>
                                </wx-open-launch-weapp>
                            </div>

                            <!--                <button type="button" class="button block orangeButton">返回课件小程序</button>-->

                            <div style="margin-top: 32px;">
                                <adModule :type="adTypeEnum.DOWNLOADING_COUNT_RECHARGE_SUCCESS.code" version="4"/>
                            </div>
                        </div><!-- end success view -->

                    </van-tab>

                    <van-tab title="课件网指南" title-style="font-size: 14px;">
                        <article class="paddingH8">
                            <div class="content" v-html="vipEnjoyData ? vipEnjoyData.fingerpost[0].content : ''"></div>
                        </article>
                    </van-tab>

                    <van-tab title="专属客服" title-style="font-size: 14px;">
                        <article class="paddingH8">
                            <div class="content" v-html="vipEnjoyData ? vipEnjoyData.service[0].content : ''"></div>
                        </article>
                    </van-tab>

                </van-tabs>
            </div>

        </div>

        <div style="height: 120px;" v-if="view === 'recharge'">
            <div class="fixedBottom white_bg" style="height: 120px;">
                <div class="alignC f12 grey20 lineHeight20r12">
                    <div class="centered" style="width: fit-content">
                        <label class="grey20" style="display: flex; align-items: center">
                            <input type="checkbox" class="redCircleTickCheckbox" style="width: 12px; height: 12px; "
                               v-model="agreeLicense"/> 同意师讯
                            <router-link class="red" to="/help/rechargeLicense">《师讯课件网小程序充值服务协议》</router-link>
                        </label>
                    </div>
                </div>

                <div class="marginT12">
                    <div class="paddingH16">
                        <button type="button" class="button block orangeButton payButton font18r" :disabled="!agreeLicense"
                            @click="submit()">
                            立即支付<span v-if="activeOption">{{activeOption.price}}元</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

<!--        <distributeButton @sharePoster="sharePoster()"/>-->

        <coursePayDialog ref="payDialog" type="miniCourseWare" :onPaySuccess="onPaySuccess"
            agreeServiceName="师讯课件网小程序充值服务协议"/>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// data
import adTypeEnum   from '@/components/ad/adTypeEnum';
import externalApp  from '@/data/externalApp';

import vipApi from '@/api/vip';
import VipTypeBroadSenseEnum from '@/data/VipTypeBroadSenseEnum';

// modules
import {Tab, Tabs}          from 'vant';
import coursePayDialog      from '@/components/vodCourse/coursePayDialog';
import adModule             from '@/components/ad/oneImageAdModule'
import distributeButton     from '@/components/distribution/distributeButton';
import BuyNotice            from "@/components/contentModule/buyNotice";

// util
import consoleApi       from '@/components/platformApi/consoleApi';
import requestManager   from "@/components/platformApi/requestManager";
import userUtil         from "@/components/shixunApp/userUtil";
import consoleHelper    from "@/util/consoleHelper";
import wechatHelper     from "@/util/wechatHelper";
import appHelper        from '@/util/appHelper';
import urlHelper        from '@/util/urlHelper';

const config = {
    name : 'rechargeLimitOfDownload',
    title : '次数充值',
    description : '',
    apiConfig : {
    },
    demoPackageOptions : [{
        rechargeCount : 5,
        price : 5,
        currencyUnit : '元'
    },{
        rechargeCount : 10,
        price : 9,
        currencyUnit : '元'
    },{
        rechargeCount : 20,
        price : 15,
        currencyUnit : '元'
    },{
        rechargeCount : 30,
        price : 22,
        currencyUnit : '元'
    },{
        rechargeCount : 40,
        price : 30,
        currencyUnit : '元'
    },{
        rechargeCount : 50,
        price : 35,
        currencyUnit : '元'
    }]
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {
        'van-tab': Tab,
        'van-tabs': Tabs,
        BuyNotice, coursePayDialog, adModule, distributeButton
    },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            enableDataList : true,
            enableDataItem : true,
            view : 'recharge',
            dataItem : {
                account : ''
            },
            activeOption : null,
            agreeLicense : false,
            activeType: 0,
            downloadCount : 0,
            adTypeEnum : adTypeEnum,
            externalApp : externalApp,

            userInstance : null,
            vipEnjoyData : null
        }
    },
    methods : {
        loadCourseWare() {
            requestManager.request({
                url : 'portal/mini/courseware'
            }, (error, result) => {
                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }

                this.dataList = result.data.configList;
                if (this.dataList.length)
                {
                    this.activeOption = this.dataList[0];
                }
                this.downloadCount = result.data.count;
            })
        },
        setWechatShare : function() {

            // 检查登录后和加载数据后执行，必要条件：详情数据、已检查登录状态

            if (!this.dataItem || !this.userInstance)
            {
                return;
            }

            let link = '';

            if (!this.userInstance)
            {
                link = appHelper.generateShareUrl('/recharge/limitOfDownload');
            }
            else
            {
                link = appHelper.generateShareUrl('/recharge/limitOfDownload/promotion/:promotionCode', {
                    ':promotionCode' : this.userInstance.introduceCode
                });
            }

            const wechatShareOptions = {
                title   : this.title,
                desc    : this.description,
                link    : link,
                imgUrl  : appHelper.getAppIcon()
            };
            wechatHelper.setShare(wechatShareOptions);
        },
        submit() {
            if (!this.dataItem.account)
            {
                appHelper.showHint('请输入账号或手机帐号');
                return;
            }
            if (!this.agreeLicense)
            {
                appHelper.showHint('请阅读并同意服务协议');
                return;
            }

            this.$refs.payDialog.setProduct({
                id      : this.activeOption.id,
                title   : '次数充值',
                image   : appHelper.getAppIcon(),
                price   : this.activeOption.price,
                payMessage : this.dataItem.account
            });
            this.$refs.payDialog.open();
        },
        onPaySuccess() {
            this.view = 'success';
            this.$refs.payDialog.hide();
        },
        onLaunchWeApp(e) {
            consoleApi.log('launch weapp success', e);
        },
        onLaunchWeAppError(e) {
            consoleApi.log('launch weapp fail', e.detail);
        },
    },
    mounted() {
        this.loadCourseWare();
        let view = urlHelper.getUrlParam('view') || '';
        if (view)
        {
            this.view = view;
        }

        let promotionCode = this.$route.params.promotionCode || '';
        const me = this;

        appHelper.checkLogin((error, userData) => {

            if (error) {
                return;
            }

            consoleHelper.logDebug('user base info:');
            consoleHelper.logDebug('user name: ' + userData ? userData.userName : '游客');
            if (userData) {
                me.userInstance = userUtil.createUser(userData);

                consoleHelper.logDebug('user has course vip: ' +
                    me.userInstance.isContentHasVipPrivilege('course_vod'))
            }

            me.setWechatShare();

        }, {
            promotionCode: promotionCode
        });

        vipApi.loadVipEnjoyInfo(VipTypeBroadSenseEnum.COURSE_WARE.code, (result) => {
            me.vipEnjoyData = result.data;
        });
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: hsla(0, 100%, 62%, 1);
}
.lightGrey {
    color: hsla(219, 16%, 60%, 1);
}
.orange {
    color: #ffa724;
}
.darkgrey {
    color: hsla(219, 9%, 39%, 1);
}
.moreContentRightAngleBracketIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAcUlEQVQ4je3UoRGAMAyF4UhG6JiMgIPENtW1TaZA4BBIpqFFoJBcKuhd/wG+u2ceQJNNMQ7oZUNOOwV1ZpCCOmLN6KUsnM4qKHIakeXqaEMoshx1wWAE35PVNrlj36OgDr0UYs1mDOC5r9nLWu2+ftUNsey4KFamucAAAAAASUVORK5CYII=');
}
.optionsArea {
    .optionItem {
        background: hsla(0, 0%, 98%, 1);
        border: solid 1px transparent;
        box-sizing: border-box;
        padding: 13px 0;

        .countText {
            color: hsla(219, 9%, 39%, 1);
        }
        .priceText {
            color: hsla(219, 16%, 60%, 1);
        }

        &.active {
            background: #FFF8ED;
            border-color: hsla(36, 100%, 57%, 1);
            color: hsla(36, 100%, 57%, 1);

            .countText, .priceText {
                color: hsla(36, 100%, 57%, 1);
            }
        }
    }
}
.orangeButton {
    border: none;
    height: 48px;
    line-height: 48px;
    border-radius: 24px;
    padding: 0;
    background: linear-gradient(90deg, #FFA115 0%, #FFBF60 100%);
    color: white;
    &:disabled {
        opacity: .6;
    }
}
</style>
